export default {
    megatrends: 'Mega-trends',
    macrotrends: 'Macro-trends'
}
